import LikesMain from "../../component/Member/components/Likes/LikesMain";
import NavBar from "../../component/NavBar/NavBar";

function Likes() {
    return (
        <>
            <NavBar />
            <LikesMain />
        </>
    );
}

export default Likes;